import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.less']
})
export class TagComponent implements OnInit {

  @Input() isDisabled: boolean = false;
  @Input() isRemovable: boolean = false;
  @Input() customClass: string = 'dark';
  @Input() label: string = '';
  @Input() showTagCount: boolean = false;
  @Input() count: number = 0;
  @Input() tagIcon: string = '';

  @Output() removed = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

}
